import { Apps } from '../apps'
import Extensions from '../models/extensions'
import { ESubscription } from './user/user'

export enum EServices {
	Steam,
	CSDeals,
	CSMoney,
	CSTrade,
	LF,
	Swap,
	Tradeit,
	TradeSkinsFast,
	Bitskins,
	Buff, // pro
	C5game, // pro
	CSDealsMarket,
	DMarket,
	Igxe, // pro
	Shadowpay, // pro
	Skinbaron, // pro
	Skinport, // pro
	TM,
	Waxpeer, // pro
	BuffMarket, // pro
	VMarket, // pro
	SkinsMonkey,
	SkinSwap,
	CsFail, // secret
	LisSkins, // pro
	SwapMarket,
	BitskinsP2P, // pro
	CsFloat, // pro
	TMNew,
	CsMoneyMarket, // pro
	ITrade,
	SkinoutMarket, // pro
	WhiteMarket, // pro
	DMarketP2P, // pro
	AvanMarket, // pro
	RapidSkins, //pro
	SkinThunder, //pro
	SkinBid, //pro
	Mannco, //pro
	HaloSkins, //pro
	SkinFlow, //pro
	SkinDeck, //pro
	CSGO500, //secret
	Youpin898, //pro
	ManncoTrade, //pro
	RustSkins, //pro
	SnipeSkins, //pro
	PirateSwap, //pro
	SecretLF, // SECRET
	SecretTradeit, // SECRET
	SteamTrader,
	SkinPlace, // pro
	AimMarket, // pro
	Krakatoa, //pro
	ClashGg, // pro
	DropSkin, // pro
	Skinrave, // pro
	CsGoEmpire, // pro
	Skinland, // pro
	Csgoroll, // pro — CS2 P2P withdraw
}

export enum ESalesPeriod {
	Week,
	Day,
	Month,
	Month3,
}

export enum EPriceType {
	Normal,
	Deposit,
	Order,
	Average,
	NoHold,
}

export enum EType {
	None,
	OverstockAndUnavailable,
	Favorites,

	Csgo_Stattrak,
	Csgo_Knife,
	Csgo_Glove,
	Csgo_Souvenir,
	Csgo_Sticker,
	Csgo_Agent,
	Csgo_Patch,
	Csgo_Container,
	Csgo_Graffiti,

	Dota_1_Common,
	Dota_1_Uncommon,
	Dota_1_Rare,
	Dota_1_Mythical,
	Dota_1_Immortal,
	Dota_1_Legendary,
	Dota_1_Arcana,
	Dota_1_Ancient,

	Dota_2_Inscribed,
	Dota_2_Auspicious,
	Dota_2_Heroic,
	Dota_2_Genuine,
	Dota_2_Autographed,
	Dota_2_Frozen,
	Dota_2_Cursed,
	Dota_2_Corrupted,
	Dota_2_Infused,
	Dota_2_Unusual,
	Dota_2_Exalted,
	Dota_2_Elder,
	Dota_2_Legacy,
	Dota_2_Ascendant,
	Dota_2_Favored,

	Tf_Tool,
	Tf_Gift,
	Tf_SupplyCrate,
	Tf_Recipe,

	Rust_Weapon,
	Rust_Misc,
	Rust_ClothingArmor,
	Rust_Resource,

	Csgo_Tools,
	Csgo_Pins,
	Csgo_Passes,
	Csgo_Gifts,
	Csgo_MusicKits,
}

export enum ETypeValue {
	None,
	Without,
	Only,
}

export enum ESortType {
	PriceDesc,
	PriceAsc,
	LiquidityDesc,
	LiquidityAsc,
}

export class TableHelper {
	static AppIds: Set<number> = new Set<number>([
		Apps.CsGo,
		Apps.Rust,
		Apps.Dota2,
		Apps.Tf2,
	])

	static GetServiceName(service: EServices): string {
		switch (service) {
			case EServices.LF:
				return 'LootFarm'
			case EServices.TM:
				return 'TMarket'
			case EServices.VMarket:
				return 'VMarket (Dangerous)'
			case EServices.CsFail:
				return 'Fail'
			case EServices.LisSkins:
				return 'Lis-Skins'
			case EServices.SwapMarket:
				return 'Swap Market'
			case EServices.BitskinsP2P:
				return 'Bitskins P2P'
			case EServices.CsFloat:
				return 'CS Float'
			case EServices.TMNew:
				return 'TMarket New'
			case EServices.CSMoney:
				return 'CS.MONEY'
			case EServices.CsMoneyMarket:
				return 'CS.MONEY Market'
			case EServices.ITrade:
				return 'iTrade'
			case EServices.SkinoutMarket:
				return 'Skinout'
			case EServices.WhiteMarket:
				return 'White Market'
			case EServices.AvanMarket:
				return 'AvanMarket'
			case EServices.RapidSkins:
				return 'RapidSkins'
			case EServices.SkinThunder:
				return 'SkinThunder'
			case EServices.SkinBid:
				return 'SkinBid'
			case EServices.Mannco:
				return 'Mannco'
			case EServices.HaloSkins:
				return 'HaloSkins'
			case EServices.SkinFlow:
				return 'SkinFlow'
			case EServices.SkinDeck:
				return 'SkinDeck'
			case EServices.CSGO500:
				return 'CSGO500'
			case EServices.Youpin898:
				return 'Youpin898'
			case EServices.ManncoTrade:
				return 'ManncoTrade'
			case EServices.RustSkins:
				return 'RustSkins'
			case EServices.SnipeSkins:
				return 'SnipeSkins'
			case EServices.Shadowpay:
				return 'Shadowpay'
			case EServices.PirateSwap:
				return 'PirateSwap'
			case EServices.SecretLF:
				return 'Secret LootFarm'
			case EServices.SecretTradeit:
				return 'Secret Tradeit'
			case EServices.ClashGg:
				return 'Clash.gg'
			case EServices.DropSkin:
				return 'DROP.SKIN'
			case EServices.Skinrave:
				return 'Skinrave'
			case EServices.CsGoEmpire:
				return 'CSGOEmpire'
			case EServices.Skinland:
				return 'Skin.Land'
			case EServices.Csgoroll:
				return 'CSGORoll'

			default:
				return EServices[service]
		}
	}

	// Validations

	static CheckServiceByAppId(service: EServices, appId: number): boolean {
		switch (service) {
			// BitSkins закрылся — прячем во всех играх. Зеркало бэкенда
			// (Shared/Models/TableHelper.cs, VVT-208 #1 от 16.07.2026): там те же две
			// строки. Эти Check*-методы продублированы в двух репозиториях и обязаны
			// совпадать — правка только в бэке дала бы «данных нет, а колонка есть».
			// BitskinsP2P отдельного case не имел и дефолтил в true — висел пустым
			// сервисом, теперь закрыт явно. Значения enum НЕ удаляем: он append-only,
			// изъятие сдвинет номера всех следующих сервисов в трёх репозиториях.
			case EServices.Bitskins:
			case EServices.BitskinsP2P:
				return false
			// case EServices.VMarket:
			// 	return appId !== Apps.Tf2
			case EServices.BuffMarket:
				return appId === Apps.CsGo
			case EServices.CSMoney:
				return appId === Apps.CsGo //|| appId === Apps.Dota2
			case EServices.Shadowpay:
				return (
					appId === Apps.CsGo || appId === Apps.Dota2 || appId === Apps.Rust
				)
			case EServices.SkinsMonkey:
				return appId === Apps.CsGo || appId === Apps.Tf2 || appId === Apps.Rust
			case EServices.Swap:
				return appId === Apps.CsGo || appId === Apps.Tf2 || appId === Apps.Rust
			case EServices.SkinSwap:
				return appId === Apps.CsGo || appId === Apps.Rust
			case EServices.Skinbaron:
				return appId === Apps.CsGo
			case EServices.CsFail:
				return (
					appId === Apps.CsGo || appId === Apps.Dota2 || appId === Apps.Rust
				)
			case EServices.LisSkins:
				return (
					appId === Apps.CsGo || appId === Apps.Dota2 || appId === Apps.Rust
				)
			// case EServices.SwapMarket:
			// 	return appId === Apps.CsGo || appId === Apps.Dota2 || appId === Apps.Rust || appId === Apps.Tf2
			case EServices.CsFloat:
				return appId === Apps.CsGo
			case EServices.TMNew:
				return appId === Apps.CsGo
			case EServices.CsMoneyMarket:
				return appId === Apps.CsGo
			case EServices.ITrade:
				return appId === Apps.Rust || appId === Apps.CsGo
			case EServices.SkinoutMarket:
				return appId === Apps.CsGo
			case EServices.WhiteMarket:
				return appId === Apps.CsGo
			case EServices.Buff:
				return appId === Apps.CsGo || appId === Apps.Dota2
			case EServices.RapidSkins:
				return appId === Apps.CsGo || appId === Apps.Rust
			case EServices.SkinThunder:
				return appId === Apps.CsGo
			case EServices.SkinBid:
				return appId === Apps.CsGo
			case EServices.HaloSkins:
				return appId === Apps.CsGo
			case EServices.SkinFlow:
				return appId === Apps.CsGo
			case EServices.Tradeit:
			case EServices.SecretTradeit:
				return appId === Apps.CsGo || appId === Apps.Rust || appId === Apps.Tf2
			case EServices.SkinDeck:
				return appId === Apps.CsGo
			case EServices.CSGO500:
				return appId === Apps.CsGo || appId === Apps.Rust
			case EServices.Youpin898:
				return appId === Apps.CsGo
			case EServices.ManncoTrade:
				return appId === Apps.Tf2
			case EServices.RustSkins:
				return appId === Apps.Rust
			case EServices.SnipeSkins:
				return appId === Apps.Rust
			case EServices.PirateSwap:
			case EServices.Krakatoa:
				return appId === Apps.CsGo
			case EServices.SteamTrader:
				return appId === Apps.Tf2
			case EServices.SkinPlace:
				return appId === Apps.CsGo || appId === Apps.Dota2 || appId === Apps.Rust
			case EServices.AimMarket:
				// Rust убран: aim.market перестал его продавать (сентябрь 2026), их GraphQL
				// по Rust отдаёт 0 предметов, а страница Rust показывает каталог CS2.
				// Парсер по Rust отключён (VVT-235), данные замёрзли — сервис больше
				// не предлагаем в сравнении по Rust. На бэкенде то же самое (VVT-238).
				return appId === Apps.CsGo || appId === Apps.Dota2
			case EServices.ClashGg:
				return appId === Apps.CsGo
			case EServices.DropSkin:
				return appId === Apps.CsGo
			case EServices.Skinrave:
				return appId === Apps.CsGo
			case EServices.CsGoEmpire:
				return appId === Apps.CsGo
			case EServices.Skinland:
				return appId === Apps.CsGo || appId === Apps.Dota2 || appId === Apps.Rust
			case EServices.Csgoroll:
				return appId === Apps.CsGo
			default:
				return this.AppIds.has(appId)
		}
	}

	static CheckForSalesAvailable(
		service: EServices,
		period: ESalesPeriod
	): boolean {
		switch (service) {
			//case EServices.Skinport:
			case EServices.Steam:
			case EServices.DMarket:
			case EServices.WhiteMarket:
			case EServices.SkinBid:
			case EServices.Youpin898:
				return true
			//  case EServices.SwapMarket:
			case EServices.Bitskins:
			case EServices.CSDealsMarket:
			case EServices.Igxe:
			case EServices.BuffMarket:
			case EServices.BitskinsP2P:
			case EServices.CsFloat:
				return period < ESalesPeriod.Month

			//case EServices.Shadowpay:
			case EServices.Waxpeer:
			case EServices.TM:
			case EServices.VMarket:
			case EServices.TMNew:
				return period < ESalesPeriod.Month3

			// case EServices.Skinbaron:
			// 	return period < ESalesPeriod.Month
			// case EServices.CSMoney:
			// 	return true
			// case EServices.Buff:
			// 	return period < ESalesPeriod.Month
			// case EServices.C5game:
			// 	return period < ESalesPeriod.Month3

			default:
				return false
		}
	}

	static CheckServiceBySubscription(
		service: EServices,
		sub: ESubscription
	): boolean {
		return !(
			(service === EServices.Buff ||
				service === EServices.BuffMarket ||
				service === EServices.C5game ||
				service === EServices.Igxe ||
				service === EServices.Shadowpay ||
				service === EServices.Skinbaron ||
				service === EServices.Skinport ||
				service === EServices.Waxpeer ||
				service === EServices.VMarket ||
				service === EServices.LisSkins ||
				service === EServices.CsFail ||
				service === EServices.CsFloat ||
				service === EServices.BitskinsP2P ||
				service === EServices.SkinoutMarket ||
				service === EServices.WhiteMarket ||
				// service === EServices.DMarketP2P ||
				service === EServices.AvanMarket ||
				service === EServices.RapidSkins ||
				service === EServices.SkinThunder ||
				service === EServices.SkinBid ||
				service === EServices.Mannco ||
				service === EServices.HaloSkins ||
				service === EServices.SkinFlow ||
				service === EServices.SkinDeck ||
				service === EServices.CSGO500 ||
				service === EServices.Youpin898 ||
				service === EServices.ManncoTrade ||
				service === EServices.SnipeSkins ||
				service === EServices.RustSkins ||
				service === EServices.PirateSwap ||
				service === EServices.Krakatoa ||
				service === EServices.SteamTrader ||
				service === EServices.SkinPlace ||
				service === EServices.AimMarket ||
				service === EServices.ClashGg ||
					service === EServices.DropSkin ||
					service === EServices.Skinrave ||
						service === EServices.CsGoEmpire ||
						service === EServices.Skinland ||
						service === EServices.Csgoroll) &&
			sub < ESubscription.ProSubscription
		)
	}

	static CheckForSalesBySubscription(
		service: EServices,
		sub: ESubscription,
		period: ESalesPeriod,
		freeServices: Set<EServices>
	): boolean {
		if (sub >= ESubscription.ProSubscription) {
			return TableHelper.CheckForSalesAvailable(service, period)
		} else {
			return (
				period === ESalesPeriod.Week &&
				(TableHelper.CheckServiceBySubscription(service, sub) ||
					freeServices?.has(service)) &&
				TableHelper.CheckForSalesAvailable(service, period)
			)
		}
	}

	static CheckServicePriceType(
		service: EServices,
		priceType: EPriceType
	): boolean {
		switch (priceType) {
			case EPriceType.Normal:
				return true
			case EPriceType.Order:
				switch (service) {
					//case EServices.SwapMarket:
					//case EServices.VMarket:
					case EServices.Steam:
					case EServices.Buff:
					case EServices.BuffMarket:
					case EServices.DMarket:
					case EServices.Bitskins:
					case EServices.TM:
					case EServices.TMNew:
					case EServices.SkinSwap:
					case EServices.CSGO500:
					case EServices.Youpin898:
					case EServices.RustSkins:
					case EServices.CsFloat:
					case EServices.Waxpeer:
					case EServices.WhiteMarket:
						return true
					default:
						return false
				}
			case EPriceType.Deposit:
				switch (service) {
					//case EServices.CSDeals:
					case EServices.CSMoney:
					case EServices.LF:
					case EServices.SkinSwap:
					case EServices.CSTrade:
					case EServices.Tradeit:
					case EServices.ITrade:
					case EServices.SecretLF: // SECRET
					case EServices.SecretTradeit:
						return true
					default:
						return false
				}
			case EPriceType.Average:
				return this.CheckForSalesAvailable(service, ESalesPeriod.Week)
			case EPriceType.NoHold:
				switch (service) {
					case EServices.Swap:
					case EServices.CSMoney:
					case EServices.LF:
					case EServices.SkinSwap:
					case EServices.CSTrade:
					case EServices.LisSkins:
					case EServices.SkinoutMarket:
					case EServices.AvanMarket:
					case EServices.RapidSkins:
					case EServices.SkinBid:
					case EServices.ITrade:
					case EServices.SkinsMonkey:
					case EServices.SkinFlow:
					case EServices.PirateSwap:
					case EServices.DMarket:
					case EServices.SkinPlace:
					case EServices.AimMarket:
					case EServices.Skinland:
					case EServices.SecretLF: // SECRET
						return true
					default:
						return false
				}
			default:
				return false
		}
	}

	static CheckServiceIsMarket(service: EServices): boolean {
		switch (service) {
			// case EServices.DMarketP2P:
			// case EServices.SwapMarket:
			case EServices.Steam:
			case EServices.Bitskins:
			case EServices.Buff:
			case EServices.C5game:
			case EServices.CSDealsMarket:
			case EServices.DMarket:
			case EServices.Igxe:
			case EServices.Shadowpay:
			case EServices.Skinbaron:
			case EServices.Skinport:
			case EServices.TM:
			case EServices.Waxpeer:
			case EServices.BuffMarket:
			case EServices.VMarket:
			case EServices.LisSkins:
			case EServices.BitskinsP2P:
			case EServices.CsFloat:
			case EServices.TMNew:
			case EServices.CsMoneyMarket:
			case EServices.SkinoutMarket:
			case EServices.WhiteMarket:
			case EServices.AvanMarket:
			case EServices.SkinThunder:
			case EServices.SkinBid:
			case EServices.Mannco:
			case EServices.HaloSkins:
			case EServices.SkinDeck:
			case EServices.Youpin898:
			case EServices.RustSkins:
			case EServices.SnipeSkins:
			case EServices.Krakatoa:
			case EServices.SteamTrader:
			case EServices.SkinPlace:
			case EServices.AimMarket:
			case EServices.ClashGg:
			case EServices.DropSkin:
			case EServices.Skinrave:
			case EServices.Skinland:
			case EServices.Csgoroll:
				return true
			default:
				return false
		}
	}

	static CheckServiceIsRoulette(service: EServices): boolean {
		switch (service) {
			case EServices.CsFail:
			case EServices.CSGO500:
			case EServices.CsGoEmpire:
				return true
			default:
				return false
		}
	}

	static CheckServiceForLinks(service: EServices): boolean {
		switch (service) {
			//case EServices.SwapMarket:
			case EServices.Buff:
			case EServices.BuffMarket:
			case EServices.C5game:
			case EServices.DMarket:
			case EServices.Skinport:
			case EServices.Youpin898:
				return true
			default:
				return false
		}
	}

	static CheckServiceForDepositCalculate(service: EServices): boolean {
		switch (service) {
			// синхронно с бэкендом (Shared/Models/TableHelper.cs: CSMoney/LF/SecretLF/CSTrade) —
			// иначе Deposit-цена в PriceCheck расходится с основной таблицей на величину fee
			case EServices.CSMoney:
			case EServices.LF:
			case EServices.SecretLF:
			case EServices.CSTrade:
				return true
			default:
				return false
		}
	}

	static CheckServiceForSecret(service: EServices): boolean {
		switch (service) {
			case EServices.SecretLF:
			case EServices.SecretTradeit:
				return true
			default:
				return false
		}
	}

	static CheckServiceExists(service: EServices): boolean {
		return service in EServices
	}

	// Закрытые/удалённые сервисы — прячем из ВСЕХ пользовательских списков
	// (селектор сервиса, настройки, статус-страница, FAQ, инвентарь, подписка).
	// Enum append-only (удалять значения нельзя — сдвинет номера сервисов в трёх
	// репозиториях), поэтому скрываем явным флагом. BitSkins закрылся (VVT-208 #1):
	// ценовую колонку уже прячет CheckServiceByAppId, но списки-перечисления её не
	// учитывали, и сервис всплывал в UI — начальник просил убрать отовсюду.
	static CheckServiceIsHidden(service: EServices): boolean {
		switch (service) {
			case EServices.Bitskins:
			case EServices.BitskinsP2P:
				return true
			default:
				return false
		}
	}
}

export class ItemType {
	constructor(
		description: string,
		availableValues: ETypeValue[] | null = null,
		defaultValue: ETypeValue = ETypeValue.None,
		onlyWith: EType = null
	) {
		this.Description = description
		this.AvailableValues = availableValues ?? [
			ETypeValue.None,
			ETypeValue.Without,
			ETypeValue.Only,
		]
		this.OnlyWith = onlyWith

		this.TypeValue = defaultValue
		this._current = defaultValue
	}

	OnlyWith?: EType
	Description: string
	AvailableValues: ETypeValue[] = [
		ETypeValue.None,
		ETypeValue.Without,
		ETypeValue.Only,
	]

	TypeValue: ETypeValue

	private _current: number

	NextValue(hasOnly: boolean): ETypeValue {
		let value = this.AvailableValues[this.GetCurrent()]

		return (this.TypeValue =
			hasOnly && value === ETypeValue.Only
				? this.AvailableValues[this.GetCurrent()]
				: value)
	}

	SetTypeValue(typeValue: ETypeValue): void {
		this.TypeValue = typeValue
		this._current = typeValue
	}

	GetCurrent(): number {
		return ++this._current >= this.AvailableValues.length
			? (this._current = 0)
			: this._current
	}
}

export class ItemTypeController {
	constructor(
		types: Map<string, Map<EType, ItemType>>,
		combinable: boolean = true
	) {
		this.Types = types
		this._combinable = combinable
	}

	_combinable: boolean

	HasOnly(key: string, type: EType): boolean {
		const array = new Array<{
			key: EType
			value: ItemType
		}>()

		for (const type of Extensions.GetEnumValues(EType)) {
			if (this.Types.get(key).has(type)) {
				array.push({ key: type, value: this.Types.get(key).get(type) })
			}
		}

		return (
			this._combinable &&
			array.some(
				x =>
					x.value.TypeValue === ETypeValue.Only &&
					!ItemTypeController.CanCombine(x, {
						key: type,
						value: this.Types.get(key).get(type),
					})
			)
		)
	}

	static CanCombine(
		t1: { key: EType; value?: ItemType },
		t2: { key: EType; value?: ItemType }
	): boolean {
		return t1.value?.OnlyWith === t2.key || t2.value?.OnlyWith === t1.key
	}

	Types: Map<string, Map<EType, ItemType>>
}
